import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR } from "./webgl0.js";

function Scene() {
  this.vertexShader = `#version 300 es
  in vec3 aPos;
  out vec3 vPos;

  void main() {
    gl_Position = vec4(aPos, 1.0);
    vPos = aPos;
  }`;

  this.fragmentShader = `#version 300 es
  precision mediump float;

  in vec3 vPos;
  out vec4 fragColor;

  void main() {
    vec3 p = vec3(vPos.xy, sqrt(1.0 - dot(vPos, vPos)));
    fragColor = vec4(0.0);

    vec3 lightSource = vec3(1.0, 1.0, 1.0);
  
    if(p.z > 0.0) {
      float cosineValue = dot(p, lightSource);
      float d = 0.5 * max(0.0, cosineValue); // remove negative values
      fragColor = vec4(vec3(d), 1.0);
    }

  }`;
}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "16px" } }>
        <canvas ref = { canvasRef } width={400} height={400} style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "red" }} />
        <pre>{ scene?.fragmentShader }</pre>
    </div>
  );
}
